import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

interface UseRequestPasswordResetProps {
  userId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useRequestPasswordReset = ({ userId, onSuccess, onError }: UseRequestPasswordResetProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['usersRequestPasswordReset', userId],
    mutationFn: async () => {
      return await privateAxios.post(`/users/${userId}/request_password_reset`);
    },
    onSuccess,
    onError,
  });
};
